<app-page-heading [title]="selectedSubcontractor ? selectedSubcontractor.name + '\'s drivers' : 'Drivers'"></app-page-heading>

<section class="container-fluid summary-panel">
    <div class="row">
        <div class="col-xs-12">

            <select id="subcontractor-select" class="form-control input-lg" [(ngModel)]="selectedSubcontractor"
                    (change)="goToDrivers(selectedSubcontractor.id)">
                <option *ngFor="let subcontractor of subcontractors" [ngValue]="subcontractor">{{ subcontractor.name }}</option>
            </select>

            <button class="btn btn-primary btn-lg pull-right m-l-sm" [disabled]="!carrier || carrier.blocked || !selectedSubcontractor"
                    (click)="goToCreateDriver()">
                <span class="fa fa-plus"></span> Create Driver
            </button>
        </div>
    </div>

    <div class="m-t-sm">
        <app-data-filters #dataFilters [disableSearch]="emailFilter.minLengthInvalid">
            <app-data-filter-group>
                <app-data-filter-input
                    #emailFilter
                    [labelKey]="'user-dashboard.users.list.filters.email.label'"
                    [(model)]="filters.email"
                    [minLength]="3"
                    [helperKey]="'Enter at least three characters'"
                    [placeholderKey]="'user-dashboard.users.list.filters.email.placeholder'"></app-data-filter-input>
            </app-data-filter-group>
        </app-data-filters>
    </div>

    <br>

    <div class="alert alert-warning" *ngIf="carrier && carrier.blocked">
        <i class="fa fa-warning"></i>
        <em>The carrier of this subcontractor is currently disabled.</em>
    </div>

    <div class="row">
        <div class="col-md-12">
            <div class="ibox float-e-margins">
                <div class="ibox-content no-padding">
                    <app-user-table #userTable
                                    *ngIf="subcontractorId"
                                    [loadPage]="loadPage"
                                    [showCarrier]="!selfCarrierMode"
                                    [showSubcontractor]="true"
                                    [(filters)]="filters"
                                    [filtersComponent]="dataFilters"
                                    (filtersReset)="filters.reset()"
                                    (edit)="goToEditDriver($event)"></app-user-table>
                </div>
            </div>
        </div>
    </div>
</section>
